import { motion } from "framer-motion";
import styled from "styled-components";
import { row } from "@ui/components/layout";

export const CloseButton = styled(motion.div)`
	cursor: pointer;
	${row(0, "center", "center")};
	position: absolute;
	top: 15px;
	right: 15px;

	&:hover svg {
		transform: rotate(90deg);
	}
	svg {
		transition: transform 0.2s ease-in-out;
		path {
			fill: ${({ theme }) => theme.colors.textSecondary};
		}
	}
`;
